"use strict";
// reference enumeration for all available denominations
Object.defineProperty(exports, "__esModule", { value: true });
exports.Denomination = void 0;
var Denomination;
(function (Denomination) {
    Denomination[Denomination["ONE_CENT"] = 1] = "ONE_CENT";
    Denomination[Denomination["TWO_CENT"] = 2] = "TWO_CENT";
    Denomination[Denomination["FIVE_CENT"] = 5] = "FIVE_CENT";
    Denomination[Denomination["TEN_CENT"] = 10] = "TEN_CENT";
    Denomination[Denomination["TWENTY_FIVE_CENT"] = 25] = "TWENTY_FIVE_CENT";
    Denomination[Denomination["FIFTY_CENT"] = 50] = "FIFTY_CENT";
    Denomination[Denomination["ONE_DOLLAR"] = 100] = "ONE_DOLLAR";
    Denomination[Denomination["TWO_DOLLAR"] = 200] = "TWO_DOLLAR";
    Denomination[Denomination["THREE_DOLLAR"] = 300] = "THREE_DOLLAR";
    Denomination[Denomination["FOUR_DOLLAR"] = 400] = "FOUR_DOLLAR";
    Denomination[Denomination["FIVE_DOLLAR"] = 500] = "FIVE_DOLLAR";
    Denomination[Denomination["TEN_DOLLAR"] = 1000] = "TEN_DOLLAR";
    Denomination[Denomination["TWENTY_DOLLAR"] = 2000] = "TWENTY_DOLLAR";
    Denomination[Denomination["TWENTY_FIVE_DOLLAR"] = 2500] = "TWENTY_FIVE_DOLLAR";
    Denomination[Denomination["FORTY_DOLLAR"] = 4000] = "FORTY_DOLLAR";
    Denomination[Denomination["FIFTY_DOLLAR"] = 5000] = "FIFTY_DOLLAR";
    Denomination[Denomination["HUNDRED_DOLLAR"] = 10000] = "HUNDRED_DOLLAR";
    Denomination[Denomination["TWO_HUNDRED_DOLLAR"] = 20000] = "TWO_HUNDRED_DOLLAR";
    Denomination[Denomination["THREE_HUNDRED_DOLLAR"] = 30000] = "THREE_HUNDRED_DOLLAR";
    Denomination[Denomination["FIVE_HUNDRED_DOLLAR"] = 50000] = "FIVE_HUNDRED_DOLLAR";
})(Denomination || (exports.Denomination = Denomination = {}));
//# sourceMappingURL=Denomination.js.map